// src/stores/dialog.js
import { defineStore } from "pinia";

const BUTTON_SETS = {
  "ok": ["ok"],
  "ok-cancel": ["cancel", "ok"],
  "yes-no": ["no", "yes"],
  "yes-no-cancel": ["cancel", "no", "yes"],
};

export const useDialogStore = defineStore("dialog", {
  state: () => ({
    open: false,
    title: "",
    message: "",
    variant: "info", // 'info' | 'success' | 'warn' | 'error'
    buttons: "ok",    // 'ok' | 'ok-cancel' | 'yes-no' | 'yes-no-cancel'
    persistent: false,
    resolveFn: null,
    confirmLabel: "OK",
    queue: [],
  }),
  getters: {
    buttonList(state) {
      return BUTTON_SETS[state.buttons] ?? BUTTON_SETS["ok"];
    },
    primaryAction(state) {
      // the "affirmative" action for Enter key, highlights as primary
      if (state.buttons.startsWith("ok")) return "ok";
      return "yes";
    },
  },
  actions: {
    confirm({
      title = "Please confirm",
      message = "",
      buttons = "ok",
      variant = "info",
      persistent = false,
      confirmLabel = "OK",
    } = {}) {
      if (this.open) return new Promise(resolve => this.queue.push({ options: { title, message, buttons, variant, persistent, confirmLabel }, resolve }));
      this.confirmLabel = confirmLabel;
      this.title = title;
      this.message = message;
      this.buttons = buttons;
      this.variant = variant;
      this.persistent = persistent;
      this.open = true;

      return new Promise((resolve) => {
        this.resolveFn = resolve;
      });
    },
    _resolve(result) {
      // result is one of: 'ok' | 'cancel' | 'yes' | 'no'
      this.open = false;
      const r = this.resolveFn;
      this.resolveFn = null;
      if (r) r(result);
      const next = this.queue.shift();
      if (next) this.confirm(next.options).then(next.resolve);
    },
    _onEsc() {
      if (this.persistent) return;
      // sensible default for Esc: prefer 'cancel' if available; else 'no'; else close 'ok'
      const pref = this.buttonList.includes("cancel")
        ? "cancel"
        : this.buttonList.includes("no")
        ? "no"
        : "ok";
      this._resolve(pref);
    },
  },
});
